import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useApp } from '../context/AppContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useApp();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <Spin size="large" tip="Loading..." />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
